import React from "react";
import ConnectionForm from "./ConnectionForm";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";


const ConnectionCreate = () => {
    return(
        <div>
            <SideNavigation current="sources"/>
            <div className="page-order">
                <NavigationBar />
                <div id="connection-form-page-div">
                    <ConnectionForm id={new URLSearchParams(window.location.search).get("id") === null ? null:new URLSearchParams(window.location.search).get("id")}/>
                </div>
            </div>
        </div>
    );
};

export default ConnectionCreate;
